/**
 * CSV for a report's blocks. Pure, so what lands in the file is testable
 * without a DOM, and built from exactly what the block draws.
 */
import type { BoardroomListCard, BoardroomReportBar } from '../../../../types';
import { toCsv } from '../download';

/** A table block: its columns as the header, its rows as drawn. */
export function tableBlockCsv(data: BoardroomListCard): string {
  const header = data.columns.map(c => c.label);
  const rows = data.rows.map(r => data.columns.map(c => r.cells[c.key] ?? ''));
  return toCsv([header, ...rows]);
}

/** A count block: one line per group, with the names in it. */
export function countBlockCsv(bars: BoardroomReportBar[]): string {
  return toCsv([
    ['group', 'count', 'rows'],
    ...bars.map(b => [b.label, b.count, b.items.map(i => i.title).join('; ')]),
  ]);
}
